<template>
  <div class="top-menu-links">
    <div class="items" v-for="(item, index) in info" :key="index">
      <a :href="item.url">{{ item.label }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderTopNav",
  data() {
    return {};
  },
  props: {
    info: Array
  }
};
</script>

<style lang="scss" scoped>
.items {
  margin-top: 0.45em;
  padding: 0 0.35em;
  border-right: 1px solid $black;
  &:last-child {
    border-right: none;
  }
  a {
    color: $black;
    &:hover {
      background-color: $light-gray;
      color: $blue;
    }
  }
}
</style>
